import {createQueryKeys} from "../../shared/query/query-keys";

export const expedientKeys = createQueryKeys("expedients");
export const expedientMutationKeys = {
  createExpedient: ["expedients", "mutation", "create-expedient"] as const,
  updateExpedient: ["expedients", "mutation", "update-expedient"] as const,
  deleteExpedient: ["expedients", "mutation", "delete-expedient"] as const,
  restoreExpedient: ["expedients", "mutation", "restore-expedient"] as const,
  cancelExpedient: ["expedients", "mutation", "cancel-expedient"] as const,
  changeExpedientCustomer: ["expedients", "mutation", "change-expedient-customer"] as const,
  changeExpedientRepresentative: [
    "expedients",
    "mutation",
    "change-expedient-representative",
  ] as const,
  addExpedientResponsible: ["expedients", "mutation", "add-expedient-responsible"] as const,
  removeExpedientResponsible: ["expedients", "mutation", "remove-expedient-responsible"] as const,
  addExpedientNote: ["expedients", "mutation", "add-expedient-note"] as const,
  editExpedientNote: ["expedients", "mutation", "edit-expedient-note"] as const,
  removeExpedientNote: ["expedients", "mutation", "remove-expedient-note"] as const,
  openExpedientCustomerOffer: ["expedients", "mutation", "open-expedient-customer-offer"] as const,
  openExpedientCustomerOfferFromTemplate: [
    "expedients",
    "mutation",
    "open-expedient-customer-offer-from-template",
  ] as const,
} as const;
